import { render, staticRenderFns } from "./node.vue?vue&type=template&id=36f536e2&"
import script from "./node.vue?vue&type=script&lang=ts&"
export * from "./node.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports